import React, { Component } from 'react'
import { connect } from 'react-redux'

import './carownerportal.scss'

// Utils

// Actions
import { getDeliveryStatus } from '../../actions/overview'
import { getStylePortalWeb, getDataByOrderId, updateAllowNotifications, getLogoPortalStyling, updateNotificationRead } from '../../actions/settings'
import { tokenLogin, acceptTOS, getTimeLineStatus } from '../../actions/carownerportal'

import { translation } from '../../utils/helpers'
// import { CarOwnerPortalIcons } from '../../shared/elements/icons'

// Components
import StepsArea from './components/stepsArea'
import NotificationsArea from './components/notificationsArea'
import RenderFontURL from '../../shared/components/RenderFontURL'
import Modal from '../../shared/components/Modal'

// Elements
import Check from '../../shared/elements/check'
import Button from '../../shared/elements/button'
// import Icon from '../../shared/elements/icon'

const REFRESH_INTERVAL = 60000

class CarOwnerPortal extends Component {
  constructor (props) {
    super(props)
    this.getDataInterval = null
    this.state = {
      isLoading: true,
      styles: {
        FontType: 1,
        WebSafeFont: 'Verdana',
        FontURL: '',
        FontFamily: 'unset',
        BrandColor: '#000000',
        BrandColorSecondary: '#000000',
        PrimaryBackgroundColor: '#000000',
        ColoredBackground: '#000000',
        H1Size: 20,
        H1Color: '#000000',
        H2Size: 18,
        H2Color: '#000000',
        BodySize: 14,
        BodyColor: '#000000',
        NavigationSize: 0,
        NavigationColor: '#000000',
        LinkSize: 14,
        LinkColor: '#000000',
        ButtonTextSize: 14,
        ButtonTextColor: '#000000',
        ButtonStrokeColor: '#000000',
        ButtonFillColor: '#000000',
        HoverStrokeColor: '#000000',
        HoverFillColor: '#000000',
        CheckboxColor: '#000000',
        CheckboxActiveColor: '#000000'
      },
      orderId: null,
      timeLine: null,
      notifications: [],
      notificationSettings: {
        AllowedEmail: null,
        AllowedSMS: null
      },
      logo: '',
      tokenInfo: {
        CarOwnerName: '',
        CarOwnerLastName: '',
        OrderId: '',
        AcceptedTheTerm: false,
        PrivacyPolicyUrl: null,
        WelcomeText: null
      },
      showPopup: false,
      modalMode: 1,
      acceptTerm: false
    }
    this.handleSubmitFrm = this.handleSubmitFrm.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.renderFooter = this.renderFooter.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.onClickNotificationTypeAllowed = this.onClickNotificationTypeAllowed.bind(this)
    this.getTimeLineStatus = this.getTimeLineStatus.bind(this)
    this.getNotifications = this.getNotifications.bind(this)
    this.onMarkNotificationsRead = this.onMarkNotificationsRead.bind(this)
    this.getData = this.getData.bind(this)

    if (!props.params.token) {
      console.log(!props.params.token)
      props.router.push('/')
    }
  }

  componentDidMount () {
    this.props.tokenLogin(this.props.params.token).then(res => {
      this.setState({
        tokenInfo: res.data,
        orderId: res.data.OrderId,
        showPopup: !res.data.AcceptedTheTerm,
        notificationSettings: {
          AllowedEmail: res.data.AllowedEmail,  // Allowed... = if car owner has allowed the notification type
          AllowedSMS: res.data.AllowedSMS
        }}, () => {
        this.getData()
        if (this.getDataInterval) clearInterval(this.getDataInterval)
        this.getDataInterval = setInterval(this.getData, REFRESH_INTERVAL)
      })
      this.getStyle()
      this.props.getLogoPortalStyling().then(res => {
        this.setState({logo: res.data.FileURL})
      })
    })
  }

  componentWillUnmount () {
    if (this.getDataInterval) clearInterval(this.getDataInterval)
  }

  getData () {
    this.getTimeLineStatus()
    this.getNotifications()
  }

  getTimeLineStatus () {
    let orderId = this.state.orderId
    if (orderId) {
      this.props.getTimeLineStatus(orderId).then(res => {
        this.setState({timeLine: res.data})
      })
    }
  }

  getNotifications () {
    let orderId = this.state.orderId
    this.props.getDataByOrderId(orderId).then(res => {
      // Store separately the ids of the unread messages
      this.setState({
        notifications: res.data
      })
    })
  }

  onClickNotificationTypeAllowed (e) {
    e.persist()
    this.props.updateAllowNotifications({
      [e.target.name]: e.target.checked
    }).then(res => {
      this.setState({ notificationSettings: { ...this.state.notificationSettings, ...res.data } })
    })
  }

  onMarkNotificationsRead (ids) {
    if (!ids || ids.length === 0) return
    ids.map(x => {
      let request = {
        NotificationId: x,
        IsRead: true
      }
      this.props.updateNotificationRead(request)
    })
  }

  handleSubmitFrm (val) {
    this.props.acceptTOS({
      IsAccept: val
    }).then(res => {
      if (val) {
        this.handleClose()
      } else {
        this.setState({ modalMode: 0 })
      }
    })
  }

  handleClose () {
    this.setState({ showPopup: false })
  }

  getStyle () {
    this.props.getStylePortalWeb().then(res => {
      this.setState({styles: res.data, isLoading: false})
    })
  }

  renderContent () {
    if (this.state.modalMode) {
      let paragraphs = this.state.tokenInfo.WelcomeText ? this.state.tokenInfo.WelcomeText.split('\n') : []
      return (
        <div className='modal-main__content__main'>
          {paragraphs.map((x, i) => <p key={i}>{x}</p>)}
          {this.state.tokenInfo.PrivacyPolicyUrl && <p><a href={this.state.tokenInfo.PrivacyPolicyUrl}>{translation(18247)}</a></p>}
          <Check labelText={translation(18248)} labelAlignment='r' onChange={() => this.setState((prevProps) => ({...prevProps, acceptTerm: !prevProps.acceptTerm}))} checked={this.state.acceptTerm} />
        </div>
      )
    } else {
      // Declined
      return (
        <div className='modal-main__content__main'>
          <h2>{translation(18249)}</h2>
        </div>
      )
    }
  }

  renderFooter () {
    if (this.state.modalMode) {
      return (
        <div className='modal-main__content__footer'>
          <Button labelText={translation(18250)} disabled={!this.state.acceptTerm} onClick={() => this.handleSubmitFrm(true)} />
          <a href='#' onClick={() => this.handleSubmitFrm(false)}>{translation(18251)}</a>
        </div>
      )
    } else {
      return (
        <div className='modal-main__content__footer' />
      )
    }
  }

  render () {
    // Don't show page before the styling settings are loaded.
    if (this.state.isLoading) return null // Show spinner maybe?

    let bottomBarProps = {
      disabled: true,
      actionLabelText: 'buttonText',
      onActionClick: this.handleClick
    }

    let fontFamily = 'unset'
    if (this.state.styles.FontType === 1 && this.state.styles.WebSafeFont) {   // Font selected from list
      fontFamily = `"${this.state.styles.WebSafeFont}"`
    } else if (this.state.styles.FontType === 2 && this.state.styles.FontURL && this.state.styles.FontFamily) {
      fontFamily = `"${this.state.styles.FontFamily}"`
    }

    const renderStyle = () => {
      return (
        <style>{`
            :root{
              --webSafeFont: ${this.state.styles.WebSafeFont};
              --fontURL: ${this.state.styles.FontURL};
              --fontFamily: ${fontFamily};
              --brandColor: ${this.state.styles.BrandColor};
              --brandColorSecondary: ${this.state.styles.BrandColorSecondary};
              --primaryBackgroundColor: ${this.state.styles.PrimaryBackgroundColor};
              --coloredBackground: ${this.state.styles.ColoredBackground};
              --h1Size: ${this.state.styles.H1Size};
              --h1Color: ${this.state.styles.H1Color};
              --h2Size: ${this.state.styles.H2Size};
              --h2Color: ${this.state.styles.H2Color};
              --bodySize: ${this.state.styles.BodySize};
              --bodyColor: ${this.state.styles.BodyColor};
              --navigationSize: ${this.state.styles.NavigationSize};
              --navigationColor: ${this.state.styles.NavigationColor};
              --linkSize: ${this.state.styles.LinkSize};
              --linkColor: ${this.state.styles.LinkColor};
              --buttonTextSize: ${this.state.styles.ButtonTextSize};
              --buttonTextColor: ${this.state.styles.ButtonTextColor};
              --buttonStrokeColor: ${this.state.styles.ButtonStrokeColor};
              --buttonFillColor: ${this.state.styles.ButtonFillColor};
              --hoverStrokeColor: ${this.state.styles.HoverStrokeColor};
              --hoverFillColor: ${this.state.styles.HoverFillColor};
              --checkboxColor: ${this.state.styles.CheckboxColor};
              --checkboxActiveColor: ${this.state.styles.CheckboxActiveColor};
            }
          .ff-wrap{
            font-family: ${fontFamily};
          }
          .color-wrap{
            color: ${this.state.styles.BodyColor};
          }
          .branch-color{
            color: ${this.state.styles.BrandColor};
          }
          .branch-bg{
            background: ${this.state.styles.BrandColor};
          }
          .branch-border{
            border-color: ${this.state.styles.BrandColor};
          }
          .fz-wrap{
            font-size: ${this.state.styles.BodySize};
          }
          .h1-color{
            color: ${this.state.styles.H1Color};
          }
          .h1-fz{
            font-size: ${this.state.styles.H1Size};
          }
          .h2-color{
            color: ${this.state.styles.H2Color};
            font-weight: 700;
          }
          .h2-fz{
            font-size: ${this.state.styles.H2Size};
          }
          .nav-color{
            color: ${this.state.styles.NavigationColor};
          }
          .nav-fz{
            font-size: ${this.state.styles.NavigationSize};
          }
          .link-color{
            color: ${this.state.styles.LinkColor};
          }
          .link-fz{
            font-size: ${this.state.styles.LinkSize};
          }
        `}</style>
      )
    }

    const renderUserInfoBox = () => {
      return (
        <div className='carownerportal__userinfo'>
          <div className='carownerportal__notification' />
          <div className='carownerportal__username'>
            <div className='carownerportal__username__avatar branch-bg branch-border'>
              <i className='fa fa-user' />
            </div>
            <div className='carownerportal__username__information color-wrap'>
              <div className='carownerportal__username__information--top'>
                <strong>{this.state.tokenInfo.CarOwnerName} {this.state.tokenInfo.CarOwnerLastName}</strong>
              </div>
              <div className='carownerportal__username__information--bottom color-wrap'>
                <span>{this.state.tokenInfo.RegNumber}</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                <span>{translation(15102)}: {this.state.tokenInfo.OrderId}</span>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className='carownerportal carownerportal-wrap ff-wrap'>
        {this.state.styles.FontType === 2 && this.state.styles.FontURL !== '' && <RenderFontURL url={this.state.styles.FontURL} />}
        {renderStyle()}
        <header className='carownerportal__header'>
          <div className='carownerportal__logo'>
            <img src={this.state.logo} alt='Logo' />
          </div>
          {renderUserInfoBox()}
        </header>
        <section className='carownerportal__content'>
          <StepsArea timeLine={this.state.timeLine} />
          <NotificationsArea notifications={this.state.notifications} onChangeCbx={this.onClickNotificationTypeAllowed} notificationSettings={this.state.notificationSettings} />
          <Modal clickOutsideClose={false} onClose={this.handleClose} hideX show={this.state.showPopup} header={false} bottomBarProps={bottomBarProps} isLoading={false}>
            <div className='modal-main modal-main-wrap'>
              <div className='modal-main__header'>
                <img src={this.state.logo} alt='Logo' style={{ height: 40 }} />
              </div>
              <div className='modal-main__content'>
                <div className='modal-main__content__title'>
                  {this.state.modalMode ? translation(18252) : translation(18253)}
                </div>
                {this.renderContent()}
                {this.renderFooter()}
              </div>
            </div>
          </Modal>
        </section>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getDeliveryStatus,
  getDataByOrderId,
  getStylePortalWeb,
  getLogoPortalStyling,
  tokenLogin,
  acceptTOS,
  getTimeLineStatus,
  updateNotificationRead,
  updateAllowNotifications
})(CarOwnerPortal)



// WEBPACK FOOTER //
// ./src/app/pages/CarOwnerPortal/index.js